import { render, staticRenderFns } from "./VeterinaryGrooming.vue?vue&type=template&id=48800d10&scoped=true"
import script from "./VeterinaryGrooming.vue?vue&type=script&lang=js"
export * from "./VeterinaryGrooming.vue?vue&type=script&lang=js"
import style0 from "./VeterinaryGrooming.vue?vue&type=style&index=0&id=48800d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48800d10",
  null
  
)

export default component.exports